module.exports = __webpack_public_path__ + "assets/paragraph-normal.8a969825.svg";